module.exports = __webpack_public_path__ + "static/img/qs_zxz.4553141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/images/qs_zxz.png
// module id = bd0X
// module chunks = 3